<template>
  <conversation
    :collapsable="false"
    is-page="true"
    :status-id="statusId"
    :is-single-post-view="isSinglePostView"
  />
</template>

<script src="./conversation-page.js"></script>
